import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";

import { Container, Content, Image, RecoveryPassword, Text } from "./styles";
import { TextFieldLogin, Button, BottomSheet } from "../../components";
import { TextInput } from "react-native-paper";
import { api } from "../../api/api";
import { Modalize } from "react-native-modalize";
import UserContext from "../../context/user";
import ClientContext from "../../context/client";
import RegisterDriverContext from "../../context/registerDriver";
import RouteContext from "../../context/route";

const Login = () => {
  const navigation = useNavigation();
  const bottomSheetErrorRef = useRef<Modalize>(null);
  const { auth, setUser } = useContext(UserContext);
  const { setClients, setClientsSelects } = useContext(ClientContext);
  const { setDrivers, setDriversSelects } = useContext(RegisterDriverContext);
  const { setNewRoute, setAllOrders, setCompleteOrders, setIndividualOrder, setPendingOrders } = useContext(RouteContext);
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    setLoading(true);
    const data = { email, password};
    try {
      await auth(data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      bottomSheetErrorRef.current?.open();
      setLoading(false);
    }
  }

  useEffect(() => {
    setClients([]);
    setClientsSelects([]);
    setDrivers([]);
    setDriversSelects([]);
    setNewRoute([]);
    setPendingOrders([]);
    setCompleteOrders([]);
    setAllOrders([]);
    setIndividualOrder([]);
    setUser([]);
  }, []);

  return (
    <Container>
      <Content>
        <Image source={require("../../assets/images/logo.png")} />
        <TextFieldLogin label="E-mail" placeholder="E-mail" value={email} keyboardType="email-address" onChangeText={(text: string) => setEmail(text)} />
        <TextFieldLogin label="Senha" placeholder="Senha" secureTextEntry value={password} onChangeText={(text: string) => setPassword(text)} />
        <Button title="Entrar" loading={loading} onPress={handleLogin} />
        <RecoveryPassword onPress={() => navigation.navigate('RecoveryPassword')}>
          <Text>Esqueceu a senha?</Text>
        </RecoveryPassword>
      </Content>
      <BottomSheet
          bottomSheetRef={bottomSheetErrorRef}
          title="Não foi possível acessar sua conta"
          description="Verifique seus dados e tente de novo."
          textButton="Entendi"
          typeButton="filled"
          accessibilityHintButton="Entendi"
          onClose={() => bottomSheetErrorRef.current?.close()}
          onPress={() => bottomSheetErrorRef.current?.close()}
        />
    </Container>
  );
};

export default Login;
